import "./ComponentStyles/Header.css";

function Header(props) {
  return (
    <header className="navbar">
      <div className="navbar-items-container">
        <div className="navbar-header">
          <a href={`${process.env.PUBLIC_URL}/`}>
            <img src={`${process.env.PUBLIC_URL}/logos/UMBC-IEEE.png`} alt="Logo" />
          </a>
        </div>
        <a href={`${process.env.PUBLIC_URL}/`}>Home</a>
        <a href={`${process.env.PUBLIC_URL}/about`}>About Us</a>
        <a href={`${process.env.PUBLIC_URL}/events`}>Events</a>
        <a href={`${process.env.PUBLIC_URL}/resources`}>Resources</a>
      </div>
    </header>
  );
}

export default Header;
